import {useEffect, useState} from "react";
import React from "react";
import {
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoNumberInputOutlined, RaikoSectionContainer, RaikoToggleOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {PeriodService} from "../../../serverService/periodService/PeriodService";
import {css} from "@emotion/css";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function ResidenceChoiceInformation({residenceId,handleCloseDialogInfo}) {


    const service = new PeriodService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [priority, setPriority] = useState(0)
    const [menNumber, setMenNumber] = useState(0)
    const [womenNumber, setWomenNumber] = useState(0)
    const [activeForAcceptation, setActiveForAcceptation] = useState(true)
    const [activeForAutomaticAcceptance, setActiveForAutomaticAcceptance] = useState(true);
    useEffect(() => {
        if (residenceId >= 0 && typeof service !== "undefined") {
            getResidenceInfoFromServer()
        }
    }, [residenceId]);


    function getResidenceInfoFromServer() {
        loading.show()
        service.getResidenceDetail(residenceId)
            .then(response => {
                setPriority(response.priority)
                setMenNumber(response.menCapacity)
                setWomenNumber(response.womenCapacity)
                setActiveForAcceptation(response.activeForAcceptation)
                setActiveForAutomaticAcceptance(response.activeForAutomaticAcceptance)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateResidenceInfo() {
        loading.show()
        service.updateResidenceDetail(
            residenceId,
            priority,
            menNumber,
            womenNumber,
            activeForAcceptation,
            activeForAutomaticAcceptance
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            handleCloseDialogInfo()
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoSectionContainer
                title={"اطلاعات اقامتگاه"}
                hasActionButton={true}
                actionButtonOnclickWithValidation={handleUpdateResidenceInfo}
            >
                <RaikoGridThreeColumn>
                    <RaikoNumberInputOutlined
                        labelText={"اولویت"}
                        setValue={setPriority}
                        value={priority}
                        required
                    />
                    <RaikoNumberInputOutlined
                        labelText={"تعداد آقا"}
                        setValue={setMenNumber}
                        value={menNumber}
                        required
                    />
                    <RaikoNumberInputOutlined
                        labelText={"تعداد خانم"}
                        setValue={setWomenNumber}
                        value={womenNumber}
                        required
                    />
                </RaikoGridThreeColumn>
                <RaikoToggleOutlined
                    labelText={"وضعیت پذیرش"}
                    setChecked={setActiveForAcceptation}
                    checked={activeForAcceptation}/>

                <RaikoToggleOutlined
                    labelText={"بررسی خودکار درخواست"}
                    setChecked={setActiveForAutomaticAcceptance}
                    checked={activeForAutomaticAcceptance}/>


            </RaikoSectionContainer>

        </RaikoGridOneColumn>
    )
}